import { useCallback, useEffect, useState } from 'react';

/**
 * Hook to track browser tab visibility
 *
 * @returns boolean - true if tab is visible, false if hidden
 */
export default function usePageVisibility(): boolean {
  const [visible, setVisible] = useState(!document.hidden);

  const handleVisibility = useCallback(() => {
    setVisible(!document.hidden);
  }, []);

  useEffect(() => {
    document.addEventListener('visibilitychange', handleVisibility);
    return () => {
      document.removeEventListener('visibilitychange', handleVisibility);
    };
  }, [handleVisibility]); // Fixed: Added handleVisibility to deps

  return visible;
}
